import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, finalize, throwError } from 'rxjs';
import { HttpLoadingService } from '../http/services/http-loading.service';
import { isSkippedByLoadingInterceptorContext } from '@web/common';

export const HttpLoadingInterceptor: HttpInterceptorFn = (request, next) => {
  const loading = inject(HttpLoadingService);

  if (isSkippedByLoadingInterceptorContext(request)) {
    return next(request);
  }

  const { url } = request;

  loading.loadingFor(url);

  return next(request).pipe(
    finalize(() => loading.unloadingFor(url)),
    catchError((error) => {
      loading.unloadingFor(url);

      return throwError(() => error);
    }),
  );
};
